import React, { memo } from 'react';
import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ProfileIcon } from '../molecules';
import { OnAnyEventHandler } from '../helpers/CommonTypes';
import { getPictureUrl } from '@weco/common';
import { defaultPicture, Picture } from '@weco/core';

const useStyles = makeStyles(({ palette }: Theme) => ({
    root: {},
    avatarBox: {
        width: '120px',
        height: '120px',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    projectOwnerIconContainer: {
        fontSize: '12px',
        backgroundColor: palette.secondary.light,
    },
    projectOwnerIcon: {
        margin: '2px 0 0 3px',
    },
}));

interface Props {
    picture: Picture | string;
    onClick?: OnAnyEventHandler;
}

const projectAvatarBox = ({ picture, onClick }: Props) => {
    const classes = useStyles();
    const placeholderImageUrl =
        typeof picture === 'string'
            ? picture
            : getPictureUrl(picture, defaultPicture);

    return (
        <Box className={classes.avatarBox} onClick={onClick}>
            <ProfileIcon picture={placeholderImageUrl} />
        </Box>
    );
};

export const ProjectAvatarBox = memo(projectAvatarBox);
